<template>
  <div class="route-index">
    <header-component />
    <div class="main">
      <browser-detect v-if="show" v-model="show" />
      <div
        ref="routerView"
        class="route-view scrollbar course-detail"
      >
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '@/components/header'

export default {
  components: {
    HeaderComponent,
    'BrowserDetect': () => import('@/components/browserDetect' /* webpackChunkName: "BrowserDetect" */)
  },
  data () {
    return {
      show: false
    }
  },
  async created() {
    try {
      await this.$auth('get_access_token')
      this.$store.commit('HAS_TOKEN', true)
      const res = await this.$store.dispatch('getClassUserInfo', { ignoreMsg: true })
      window.Sensors.setProfile({
        edu_real_name: res.real_name,
        edu_role_id: res.role_id + '',
        edu_unit_id: res.unit_id + '',
        edu_unit_type_id: res.unit_type_id + '',
        edu_unit_province_id: res.province_id + '',
        edu_unit_city_id: res.city_id + '',
        edu_unit_district_id: res.district_id + ''
      })
      await this.$store.dispatch('getCodemaoUserInfo')
    } catch (error) {
      console.log(error)
    }
  },
  mounted () {
    const u = navigator.userAgent
    this.show =
      u.indexOf('Trident') > -1 ||
      u.indexOf('Edge') > -1 ||
      u.indexOf('QQ') > -1
  }
}
</script>

<style scoped lang="scss">
.route-view {
  padding: 20px 20px;
  flex: 1;
  max-width: calc(100% - 200px);
  overflow-y: auto;
  width: 100%;
  background: rgba(var(--primary-color-source), 0.02);
}
.route-index {
  height: 100%;
  width: 100%;
  min-height: 900px;
}
.main {
  display: flex;
  height: calc(100% - 60px);
  width: 100%;
}
.course-detail {
  padding: 0;
  max-width: 100%;
  background: #333;
}
</style>
